module.exports = __webpack_public_path__ + "img/T4-A-rc_2.71b92e67.png";